var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "right",
      "label-col": {
        span: 5
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("客户名称"),
      prop: "customerId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("客户名称"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customersList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("消息类别"),
      prop: "messageCategory"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("消息类别"),
      allowClear: ""
    },
    on: {
      change: _vm.flowTypeIdChange
    },
    model: {
      value: _vm.form.messageCategory,
      callback: function ($$v) {
        _vm.$set(_vm.form, "messageCategory", $$v);
      },
      expression: "form.messageCategory"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "AUDIT_FLOW"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核流相关")))]), _c("a-select-option", {
    attrs: {
      value: "INSURE"
    }
  }, [_vm._v(_vm._s(_vm.$t("投保相关")))]), _c("a-select-option", {
    attrs: {
      value: "TASK_LIST"
    }
  }, [_vm._v(_vm._s(_vm.$t("任务列表相关")))]), _c("a-select-option", {
    attrs: {
      value: "SURRENDER_INSURANCE"
    }
  }, [_vm._v(_vm._s(_vm.$t("退保相关")))]), _c("a-select-option", {
    attrs: {
      value: "SYSTEM_MESSAGES"
    }
  }, [_vm._v(_vm._s(_vm.$t("系统消息")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("推送场景"),
      prop: "pushScenario"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.pushScenarioPlaceholder,
      allowClear: "",
      disabled: !_vm.form.messageCategory
    },
    model: {
      value: _vm.form.pushScenario,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pushScenario", $$v);
      },
      expression: "form.pushScenario"
    }
  }, _vm._l(_vm.pushScenarioList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.pushScenario
      }
    }, [_vm._v(_vm._s(_vm.$t(item.pushScenarioName)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "eventId",
    attrs: {
      label: _vm.$t("事件ID"),
      prop: "eventId"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("事件ID"),
      allowClear: ""
    },
    model: {
      value: _vm.form.eventId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "eventId", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.eventId"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("处理状态"),
      prop: "processingStatus"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("处理状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.processingStatus,
      callback: function ($$v) {
        _vm.$set(_vm.form, "processingStatus", $$v);
      },
      expression: "form.processingStatus"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "PROCESSING"
    }
  }, [_vm._v(_vm._s(_vm.$t("处理中")))]), _c("a-select-option", {
    attrs: {
      value: "SUCCESS"
    }
  }, [_vm._v(_vm._s(_vm.$t("处理成功")))]), _c("a-select-option", {
    attrs: {
      value: "PENDING"
    }
  }, [_vm._v(_vm._s(_vm.$t("待处理")))]), _c("a-select-option", {
    attrs: {
      value: "FAIL"
    }
  }, [_vm._v(_vm._s(_vm.$t("处理失败")))]), _c("a-select-option", {
    attrs: {
      value: "CANCEL"
    }
  }, [_vm._v(_vm._s(_vm.$t("取消处理")))])], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.newSystemMessage
    }
  }, [_vm._v(_vm._s(_vm.$t("新增系统消息")))])], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.dataSource,
      pagination: _vm.pagination,
      rowKey: "index"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "remark",
      fn: function (text) {
        return [_c("a-tooltip", {
          attrs: {
            title: text,
            placement: "topLeft"
          }
        }, [_c("span", [_vm._v(_vm._s(text))])])];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.seeDetail(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]), record.processingStatus === "PENDING" ? _c("a-button", {
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.cancelHandler(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("取消处理")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };